import { Controller as BaseController } from '@hotwired/stimulus';
import { useMatchMedia } from 'stimulus-use';

export default class Controller extends BaseController {
  static targets = [
    'dropdownTasks',
    'dropdownEntity',
    'dropdownReports',
    'sidebarNav',
    'sidebarNavLink',
    'sidebarNavIcon',
    'sidebarNavSpan',
  ];
  static values = { currentLevel: String };
  static params = ['level'];

  connect() {
    useMatchMedia(this, {
      mediaQueries: {
        small: '(max-width: 576px)',
      },
    });

    // Remove any lingering hidden state when reconnecting
    this.element.classList.remove('tw-hidden');

    this.handleSidebarVisibility();

    // Bind para poder remover os listeners depois
    this.boundUpdateActiveLinks = this.updateActiveLinks.bind(this);
    this.boundHandleSidebarVisibility = this.handleSidebarVisibility.bind(this);

    // Atualizar links ativos na sidebar
    this.updateActiveLinks();

    // Adicionar event listeners para atualizar links ativos durante navegação com Turbo
    document.addEventListener('turbo:click', this.boundUpdateActiveLinks);
    document.addEventListener('turbo:before-cache', this.boundUpdateActiveLinks);
    document.addEventListener('turbo:render', this.boundUpdateActiveLinks);
    document.addEventListener('turbo:load', this.boundUpdateActiveLinks);
    document.addEventListener('turbo:frame-load', this.boundUpdateActiveLinks);

    // Listen to Turbo navigation events to update sidebar visibility
    document.addEventListener('turbo:load', this.boundHandleSidebarVisibility);
    document.addEventListener('turbo:render', this.boundHandleSidebarVisibility);
  }

  handleSidebarVisibility() {
    if (this.shouldHideSidebar()) {
      this.hideSidebar();
    } else {
      this.showSidebar();
    }
  }

  shouldHideSidebar() {
    return (
      window.location.pathname.includes('scheduled_exams/response') ||
      window.location.pathname.match(/^\/socioeconomic\/new\/\d+$/) ||
      window.location.pathname.includes('learning_trail/activity')
    );
  }

  hideSidebar() {
    this.element.classList.add('tw-hidden');
  }

  showSidebar() {
    this.element.classList.remove('tw-hidden');
  }

  disconnect() {
    // Remover event listeners
    document.removeEventListener('turbo:click', this.boundUpdateActiveLinks);
    document.removeEventListener('turbo:before-cache', this.boundUpdateActiveLinks);
    document.removeEventListener('turbo:render', this.boundUpdateActiveLinks);
    document.removeEventListener('turbo:load', this.boundUpdateActiveLinks);
    document.removeEventListener('turbo:frame-load', this.boundUpdateActiveLinks);

    // Remove Turbo event listeners for sidebar visibility
    if (this.boundHandleSidebarVisibility) {
      document.removeEventListener('turbo:load', this.boundHandleSidebarVisibility);
      document.removeEventListener('turbo:render', this.boundHandleSidebarVisibility);
    }
  }

  isSmall() {
    this.toggle(); // closes sidebar if is small
  }

  toggle() {
    // Changes width
    $('.sidebar').toggleClass('sidebar-expanded sidebar-collapsed');

    // Hide items
    $('.sidebar-line-collapsed-hide').toggleClass('d-none');
    $('.sidebar-icon').toggleClass('fa-chevron-left fa-chevron-right');

    const sidebar = document.querySelector('.sidebar');
    const hasExpandend = sidebar.classList.contains('sidebar-expanded');

    if (hasExpandend) {
      $('.sidebar-nav-span').css('display', 'flex');
      $('.sidebar-nav-span-new').css('display', 'flex');
      $('.sidebar-collapsed-hide').css('display', 'block');
      $('.sidebar-img').removeClass('close-img-sidebar');
      $('.sidebar-close-mobile').removeClass('d-none');

      setTimeout(() => {
        $('.sidebar-nav-span').removeClass('sidebar-span-none');
        $('.sidebar-nav-span-new').removeClass('sidebar-span-none');
        $('.sidebar-collapsed-hide').removeClass('sidebar-span-none');
      }, 300);

      setTimeout(() => {
        $('.sidebar-nav-span').removeClass('sidebar-span-none');
        $('.sidebar-nav-span-new').removeClass('sidebar-span-none');
        $('.sidebar-collapsed-hide').removeClass('sidebar-span-none');
      }, 750);
    } else {
      $('.sidebar-nav-span').css('display', 'none');
      $('.sidebar-nav-span-new').css('display', 'none');
      $('.sidebar-collapsed-hide').css('display', 'none');
      $('.sidebar-img').addClass('close-img-sidebar');
      $('.sidebar-close-mobile').addClass('d-none');

      $('.sidebar-nav-span').addClass('sidebar-span-none');
      $('.sidebar-nav-span-new').addClass('sidebar-span-none');
      $('.sidebar-collapsed-hide').addClass('sidebar-span-none');

      $('.sidebar-dropdown-new').removeClass('dropdown-open-two');
      $('.sidebar-dropdown-new').removeClass('dropdown-open-five');
      $('.sidebar-dropdown-new').addClass('dropdown-close');
    }
  }

  clickLink() {
    let width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    if (width < 576) {
      this.toggle();
    }
    setTimeout(() => this.updateActiveLinks(), 100);
  }

  toggleDropdownTasks(event) {
    let dropdownClass = 'dropdown-open-five';

    switch (event.params.quantity) {
      case 3:
        dropdownClass = 'dropdown-open-three';
        break;
      case 4:
        dropdownClass = 'dropdown-open-four';
        break;
    }

    if (this.dropdownTasksTarget.classList.contains('dropdown-close')) {
      this.dropdownTasksTarget.classList.replace('dropdown-close', dropdownClass);
    } else {
      this.dropdownTasksTarget.classList.replace(dropdownClass, 'dropdown-close');
    }
  }

  toggleDropdownReports() {
    this.dropdownReportsTarget.classList.toggle('show');
  }

  updateActiveLinks() {
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    this.updateTimeout = setTimeout(() => {
      const currentPath = window.location.pathname;
      const navLinks = this.element.querySelectorAll('a.nav-link');

      navLinks.forEach((link) => {
        const listItem = link.querySelector('li');
        const icon = link.querySelector('.sidebar-left-icon');
        const span = link.querySelector('.sidebar-nav-span');

        if (listItem) {
          listItem.classList.remove('tw-bg-white', 'tw-bg-opacity-100');
          listItem.classList.add('tw-bg-[#0A75D7]');
        }
        if (icon) {
          icon.classList.remove('tw-text-[#0A75D7]');
          icon.classList.add('tw-text-white');
        }
        if (span) {
          span.classList.remove('tw-text-[#0A75D7]');
          span.classList.add('tw-text-white');
        }
      });

      navLinks.forEach((link) => {
        const linkPath = link.getAttribute('href');
        if (linkPath === currentPath) {
          const listItem = link.querySelector('li');
          const icon = link.querySelector('.sidebar-left-icon');
          const span = link.querySelector('.sidebar-nav-span');

          if (listItem) {
            listItem.classList.remove('tw-bg-[#0A75D7]');
            listItem.classList.add('tw-bg-white', 'tw-bg-opacity-100');
          }
          if (icon) {
            icon.classList.remove('tw-text-white');
            icon.classList.add('tw-text-[#0A75D7]');
          }
          if (span) {
            span.classList.remove('tw-text-white');
            span.classList.add('tw-text-[#0A75D7]');
          }
        }
      });
    }, 50);
  }
}
